(function () {
  'use strict';

  function getSlideCount(splide, el) {
    if (typeof splide.length === 'number' && splide.length > 0) return splide.length;
    return el.querySelectorAll('.splide__slide').length;
  }

  function getPerPage(splide) {
    var opts = splide.options || {};
    var p = parseInt(opts.perPage, 10);
    return p > 0 ? p : 1;
  }

  function ensurePagination(el) {
    var ul = el.querySelector('.featured-products__pagination');
    if (ul) return ul;

    ul = document.createElement('ul');
    ul.className = 'featured-products__pagination';
    ul.setAttribute('aria-label', 'Slider pagination');

    var arrows = el.querySelector('.featured-products__arrows');
    if (arrows) {
      var nextBtn = arrows.querySelector('.featured-products__arrow--next');
      if (nextBtn) {
        arrows.insertBefore(ul, nextBtn);
      } else {
        arrows.appendChild(ul);
      }
    } else {
      el.appendChild(ul);
    }
    return ul;
  }

  function buildPagination(splide, el) {
    var ul = ensurePagination(el);

    var length = getSlideCount(splide, el);
    var perPage = getPerPage(splide);
    var positions = length > perPage ? length - perPage + 1 : 1;
    var activeIndex = typeof splide.index === 'number' ? splide.index : 0;

    while (ul.firstChild) ul.removeChild(ul.firstChild);

    if (positions <= 1) {
      ul.hidden = true;
      return;
    }
    ul.hidden = false;

    for (var i = 0; i < positions; i++) {
      (function (idx) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'featured-products__page';
        btn.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
        if (idx === activeIndex) btn.classList.add('is-active');
        btn.addEventListener('click', function () {
          splide.go(idx);
        });
        li.appendChild(btn);
        ul.appendChild(li);
      })(i);
    }
  }

  function updateActiveDot(el, index) {
    var btns = el.querySelectorAll('.featured-products__page');
    btns.forEach(function (btn, i) {
      btn.classList.toggle('is-active', i === index);
    });
  }

  function alignByMaxHeight(el, selector) {
    var items = el.querySelectorAll(selector);
    if (items.length < 2) return;

    items.forEach(function (it) { it.style.minHeight = ''; });

    var max = 0;
    items.forEach(function (it) {
      var h = it.getBoundingClientRect().height;
      if (h > max) max = h;
    });

    if (max > 0) {
      items.forEach(function (it) { it.style.minHeight = max + 'px'; });
    }
  }

  function alignCards(el) {
    alignByMaxHeight(el, '.product-card__title');
    alignByMaxHeight(el, '.product-card__subtitle');
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function setup(el) {
    if (el._splide) return;
    if (typeof window.Splide !== 'function') return;

    try {
      var splide = new window.Splide(el);
      var realignDebounced = debounce(function () { alignCards(el); }, 100);

      splide.on('mounted', function () {
        buildPagination(splide, el);
        alignCards(el);
      });
      splide.on('updated resized', function () {
        buildPagination(splide, el);
        alignCards(el);
      });
      splide.on('move', function (newIndex) {
        updateActiveDot(el, newIndex);
      });

      window.addEventListener('resize', realignDebounced);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { alignCards(el); });
      }

      el._splide = splide.mount();
    } catch (err) {
      console.error('Splide init failed for featured-products:', err);
    }
  }

  function init() {
    document.querySelectorAll('.featured-products__slider[data-splide]').forEach(setup);
  }

  if (typeof window.Splide === 'function') {
    init();
  } else {
    document.addEventListener('splide:ready', init, { once: true });
  }

  // Theme Editor / hot reload swap the section's markup without re-running
  // this file; the fresh slider has no `_splide` yet, so init() mounts it.
  document.addEventListener('shopify:section:load', function () {
    if (typeof window.Splide === 'function') init();
  });
})();
